import React, { forwardRef, useState } from "react";
import PropTypes from "prop-types";
import GlobalFooterCheckbox from "./GlobalFooterCheckbox";
import GlobalFooterSignUp from "./GlobalFooterSignUp";
import { ThemeProvider, Theme } from "../Theme";

import DownloadAppleStoreLogo from "../../assets/images/applestore.svg";
import DownloadGoogleStoreLogo from "../../assets/images/googlestore.svg";
import DownloadHuaweiStoreLogo from "../../assets/images/huaweistore.svg";

import styles from "./GlobalFooter.scss";

const disclaimerParagraph = (
  <p
    data-testid="global-footer-legal-disclaimer"
    className={styles.disclaimerParagraph}
  >
    Ich möchte per E-Mail Newsletter über Angebote, Produktneuheiten und
    exklusive Aktionen der Telekom Deutschland GmbH informiert werden. Die
    Einwilligung zur Newsletterzusendung kann ich jederzeit durch einen Klick
    auf den Abmeldelink am Ende jeder E-Mail widerrufen werden. Darüber hinaus
    gelten der
    <span> </span>
    <a className={styles["disclaimer-link"]} href="#data-security">
      Datenschutzhinweis Newsletterversand
    </a>
    <span> </span>
    sowie der
    <span> </span>
    <a className={styles["disclaimer-link"]} href="#general-data-security">
      Allgemeine Datenschutzhinweis
    </a>
    <span> </span>
    der Telekom Deutschland GmbH.
  </p>
);

const GlobalFooterSocial = forwardRef((props, ref) => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const { children, isVisible } = props;

  const triggerDisclaimer = () => setShowDisclaimer(true);

  if (!isVisible) {
    return "";
  }

  return (
    <div ref={ref} className={styles["social-section"]}>
      <div className={styles.newsletter}>
        <h3 className={styles.heading}>Newsletter</h3>
        <ThemeProvider value={Theme.dark}>
          <div className={styles["checkbox-group"]}>
            <div className={styles.checkbox}>
              <GlobalFooterCheckbox onChange={triggerDisclaimer}>
                Aktionsangebote Mobilfunk
              </GlobalFooterCheckbox>
            </div>
            <div className={styles.checkbox}>
              <GlobalFooterCheckbox onChange={triggerDisclaimer}>
                Aktionsangebote Festnetz
              </GlobalFooterCheckbox>
            </div>
          </div>
        </ThemeProvider>
        <GlobalFooterSignUp onFocus={triggerDisclaimer} />
        {showDisclaimer && (
          <div className={styles["disclaimer--mq-s"]}>
            {disclaimerParagraph}
          </div>
        )}
      </div>
      <div className={styles.mymagenta}>
        <h3 className={styles.heading}>MeinMagenta App</h3>
        <p className={styles.paragraph}>
          Alle Infos und bester Service für Mobilfunk &amp; Festnetz
        </p>
        <div className={styles["app-download-button-group"]}>
          <a
            className={styles["app-download-button"]}
            href="https://apps.apple.com/de/app/magentaservice/id407932476"
            aria-label="Download MeinMagenta App im Apple App Store"
          >
            <DownloadAppleStoreLogo focusable />
          </a>
          <a
            className={styles["app-download-button"]}
            href="https://play.google.com/store/apps/details?id=de.telekom.android.customercenter"
            aria-label="Download MeinMagenta App im Google Play Store"
          >
            <DownloadGoogleStoreLogo focusable />
          </a>
          <a
            className={styles["app-download-button"]}
            href="https://appgallery.huawei.com/#/app/C101431267"
            aria-label="Download MeinMagenta App in der Huawei AppGallery"
          >
            <DownloadHuaweiStoreLogo focusable />
          </a>
        </div>
      </div>
      <div className={styles["social-media"]}>
        <h3 className={styles.heading}>Social Media</h3>
        <div className={styles["social-icon-group"]}>{children}</div>
      </div>
      {showDisclaimer && (
        <div className={styles["disclaimer--mq-l-plus"]}>
          {disclaimerParagraph}
        </div>
      )}
    </div>
  );
});

GlobalFooterSocial.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  isVisible: PropTypes.bool,
};

GlobalFooterSocial.defaultProps = {
  isVisible: true,
};

GlobalFooterSocial.displayName = "GlobalFooter.Social";

export default GlobalFooterSocial;
